define("shared/utils/media-adjustments/apply-media-adjustments", ["exports", "shared/utils/media-adjustments/has-persisted-record", "shared/utils/media-adjustments/merge-media-adjustments"], function (_exports, _hasPersistedRecord, _mergeMediaAdjustments) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.applyMediaAdjustmentsToRecord = applyMediaAdjustmentsToRecord;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/media-adjustments/has-persisted-record",0,"shared/utils/media-adjustments/merge-media-adjustments"eaimeta@70e063a35619d71f
  /**
   * Merges an incoming payload into the PMI's existing media adjustments and writes the result back.
   * The single place that owns this store mutation: persisted records go through `store.push` (the
   * attribute is read-only), unsaved records are set directly. Returns the merged payload.
   */
  function applyMediaAdjustmentsToRecord(postMediaItem, payload) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const mergedPayload = (0, _mergeMediaAdjustments.mergeMediaAdjustmentsPayload)(postMediaItem.mediaAdjustments, payload, {
      preserveResolvedViolations: options.preserveResolvedViolations ?? false
    });
    if ((0, _hasPersistedRecord.hasPersistedRecord)(postMediaItem)) {
      postMediaItem.store.push({
        data: {
          id: postMediaItem.id,
          type: 'post-media-item',
          attributes: {
            mediaAdjustments: mergedPayload
          }
        }
      });
    } else {
      postMediaItem.set('mediaAdjustments', mergedPayload);
    }
    return mergedPayload;
  }
});